import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ConsultantBookingConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ConsultantBookingService } from './api/consultantBooking.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ConsultantBookingApiModule {
    public static forRoot(configurationFactory: () => ConsultantBookingConfiguration): ModuleWithProviders<ConsultantBookingApiModule> {
        return {
            ngModule: ConsultantBookingApiModule,
            providers: [ { provide: ConsultantBookingConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ConsultantBookingApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ConsultantBookingApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
